
















































	import Vue from 'vue';
	import Component from 'vue-class-component';

	import CommonSubheader from '@/components/maternite/calendrier/CommonSubheader.vue';
	import Calendrier from '@/views/Calendrier.vue';

	const Props = Vue.extend({
		props: {
			//date presume grossesse
			dpg: {
				type: String,
				default: ''
			}
		}
	});

/** The Subheader of the application */
@Component({
	components: {
		CommonSubheader
	}
})
	export default class Subheader extends Props {

		imprimer() {
			(this.$parent as Calendrier).imprimerCalendrier();
		}
	}
